import { render, staticRenderFns } from "./OrderRelatedFilesTable.vue?vue&type=template&id=2877a9d4&scoped=true"
import script from "./OrderRelatedFilesTable.vue?vue&type=script&lang=js"
export * from "./OrderRelatedFilesTable.vue?vue&type=script&lang=js"
import style0 from "./OrderRelatedFilesTable.vue?vue&type=style&index=0&id=2877a9d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2877a9d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2877a9d4')) {
      api.createRecord('2877a9d4', component.options)
    } else {
      api.reload('2877a9d4', component.options)
    }
    module.hot.accept("./OrderRelatedFilesTable.vue?vue&type=template&id=2877a9d4&scoped=true", function () {
      api.rerender('2877a9d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/AdminSummarySubs/AttachedFiles/OrderRelatedFilesTable.vue"
export default component.exports